import theme, { HEADER_HEIGHT } from '@services/theme'

export default {
    wrapper: {
        position: 'relative',
        top: HEADER_HEIGHT,
        width: '100%',
        height: '100dvh',
        backgroundColor: '#1a1a2e',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h40v40H0V0zm1 1h38v38H1V1z' fill='%232a2a3e' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        backgroundSize: '40px 40px',
        overflow: 'hidden'
    },
    whiteSectionClip: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '70%',
        height: '100%',
        backgroundColor: theme.palette.body.background,
        clipPath: 'ellipse(80% 130% at 0% 10%)'
    },
    content: {
        width: '80%',
        position: 'relative',
        padding: '2rem',
        paddingLeft: '72px',
        paddingRight: '72px',
        zIndex: 1
    }
}